<template>
  <div class="show-info">
    <!-- BUSINESS -->
    <div class="show-business">
      <router-link :to="preview ? '/event' : `/${business.url}`" class="show-business-link">
        <img v-if="show && business" :src="`${API_IMG}/${show.business}/${business.image}`"/>
        <div v-if="business">
          <span>{{ business.name }}</span>
          <span>{{ business.addressStreet }}, {{ business.addressNumber }}</span>
          <span>{{ business.addressSuburb }} - {{ business.addressCity }}</span>
        </div>
      </router-link>
    </div>
    <!-- DESCRIPTION -->
    <div class="show-description">
      <div v-if="show.online" class="online-legend">
        <template v-if="show.live && show.type !== 'Curso'"><span class="live">AO VIVO</span><span>Assista uma única apresentação deste espetáculo transmitido ao vivo na data e horário que você escolher acima.</span></template>
        <template v-else-if="show.type !== 'Curso'"><span class="online">GRAVADO</span><span>Assista este espetáculo quando quiser e quantas vezes quiser em até 7 dias.</span></template>
      </div>
      <div v-if="show" v-html="show.description"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'showDescritpion',
  props: ['business', 'show', 'preview'],
  data () {
    return {
      API_IMG: process.env.VUE_APP_IMG
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.show-info {
  display: flex;
  flex-wrap: wrap;
}

.show-description {
  flex-grow: 1;
  font-size: 1em;
  font-weight: 300;
  color: #333;
  position: relative;
  overflow: hidden;
  border-top: 1px solid #d5d5d5;
  margin: 15px 0;
  padding: 15px 0;
}

.show-business {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 100%;
  color: #333;

  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 5px;
    margin-right: 15px;
  }

  span:nth-child(1) {
    display: block;
    font-weight: 400;
    font-size: 1.4em;
  }

  span:nth-child(2), span:nth-child(3) {
    display: block;
    font-weight: 300;
    font-size: 0.9em;
  }
}

.show-business-link {
  color: #333;
  text-decoration: none;
  &:hover {
    border-radius: 5px;
    background-color: $hover-color-2;
  }
}

.online-legend {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.live {
  flex-shrink: 0;
  background-color: red;
  color: #fff;
  font-size: 9px;
  font-weight: 500;
  border-radius: 3px;
  padding: 2px 5px;
  margin-right: 10px;
}

.online {
  flex-shrink: 0;
  background-color: $primary-color;
  color: #fff;
  font-size: 9px;
  font-weight: 500;
  border-radius: 3px;
  padding: 2px 5px;
  margin-right: 10px;
}

@media screen and (min-width: $desktop-width) {

  .show-info {
    flex-wrap: nowrap;
  }

  .show-description {
    width: auto !important;
    border-top: none;
    border-right: 1px solid #d5d5d5;
    padding-top: 0;
    padding-right: 20px;
  }

  .show-business {
    order: 1;
    width: auto !important;
    flex-direction: column;
    text-align: center;
    margin: 0 auto;
    padding: 0 20px;
    img {
      width: 100px;
      height: 100px;
      margin: 15px 0;
    }
  }
}
</style>

<style lang="scss">
.show-description {
  img, video {
    max-width: 100%;
    height: auto;
  }

  p {
    line-height: 1.7;
  }
}
</style>
